import { Loading } from "views/shared/Loading";
import { Mode } from "../../components/ReadWriteTextField";
import { useAuthContext } from "AuthContextWrapper"
import { UserInfo } from "./UserInfo"

interface IProps {
  allowedModes?: Mode[],
  startMode?: Mode,
}

export function ExecutorInfo(props: IProps): JSX.Element {
  const { user, setUser } = useAuthContext()

  return user ? <UserInfo
    header={"Executor Info"}
    user={user}
    setUser={setUser}
    emailIsReadOnly={true}
    showRelationshipToDeceased={true}
    startMode={props.startMode}
    allowedModes={props.allowedModes}
  /> : <Loading />
}